import { render, staticRenderFns } from "./card-test.vue?vue&type=template&id=255edaf4&scoped=true"
import script from "./card-test.vue?vue&type=script&lang=js"
export * from "./card-test.vue?vue&type=script&lang=js"
import style0 from "./card-test.vue?vue&type=style&index=0&id=255edaf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255edaf4",
  null
  
)

export default component.exports